var outboundStaticData = null;
try {
	let { Outbound } = require('../generated/outboundStaticData');
	outboundStaticData = Outbound;
} 
catch (e) { }

export const outboundGetData = (key) => {
	if (!outboundStaticData || !key) {
		return null;
	}
	return outboundStaticData[key] || null
};